// const API_PATH = "http://192.168.222.220:50095/api";
const API_PATH = "https://pay.uoghealthcare.com/api";

export class ApiError extends Error {
    public statusCode: number;

    constructor(statusCode: number, message?: string) {
        super(message);

        this.name = "ApiError";
        this.statusCode = statusCode;
    }
}

async function apiBase<T>(version: string, method: string, path: string, body?: any): Promise<T> {
    // const fullPath = `${API_PATH}/v${version}/${path}`;
    const fullPath = `${API_PATH}/${path}`;

    const options: RequestInit = {
        body: body ? JSON.stringify(body) : undefined,
        method,
        headers: [
            ["api-version", "1"],
            ["content-type", "application/json"]
        ]
    };

    let response;
    try {
        response = await fetch(fullPath, options);
    }
    catch (e) {
        // Network error
        throw new ApiError(0, "Could not connect to server");
    }

    const contentType = response.headers.get("content-type");
    const isJson = contentType?.includes("application/json") ?? false;
    if (!response.ok) {
        if (isJson) {
            const data = await response.json();

            throw new ApiError(response.status, data?.message || data?.error?.message || response.statusText);
        }
        else {
            throw new ApiError(response.status, response.statusText);
        }
    }

    if (contentType) {
        if (isJson) {
            return response.json();
        }

        return response.blob() as Promise<any>;
    }
    else {
        return undefined as any as T;
    }
}

export const V1 = {
    get: <T>(path: string) => apiBase<T>("1", "GET", path),
    post: <T>(path: string, body?: any) => apiBase<T>("1", "POST", path, body),
    patch: <T>(path: string, body?: any) => apiBase<T>("1", "PATCH", path, body),
    put: <T>(path: string, body?: any) => apiBase<T>("1", "PUT", path, body),
    delete: <T>(path: string) => apiBase<T>("1", "DELETE", path),
}
